function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.655 0l6.263 5.053c-3.132 1.555-7.241 5.734-8.22 9.232a9.671 9.671 0 012.25-.291c4.11 0 7.535 3.207 7.535 7.968 0 4.957-4.11 9.038-9.002 9.038C5.197 31 .5 26.821.5 19.727.5 11.76 4.805 4.86 11.655 0zm22.017 0l6.262 5.053c-3.13 1.555-7.143 5.734-8.22 9.232a9.671 9.671 0 012.251-.291c4.208 0 7.535 3.207 7.535 7.968C41.5 26.92 37.39 31 32.596 31c-5.284 0-10.08-4.179-10.08-11.273C22.517 11.76 26.823 4.86 33.673 0z",
  fill: "#00ADA7"
});

function SvgDoulbleQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42 31",
    fill: "none"
  }, props), _ref);
}

export default SvgDoulbleQuote;